<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}
          <v-chip
            :color="statusColor"
            small
          >{{ isCurrentMonth ? '當前累積' : form.Status }}</v-chip>
        </span>

        <v-btn
          v-if="myLevel>=10"
          color="primary"
          dark
          class="mb-2 ml-1 mr-1"
          @click.stop="exportExcel"
        >
          <v-icon>mdi-cloud-download</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text ref="cardContent">
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <v-col cols="12">

                <v-simple-table>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td style="width: 100px">人員</td>
                        <td>
                          <avatar
                            v-if="user"
                            :user="user"
                            style="flex: 0; margin-right: 8px;"
                          />{{ user.Profile && user.Profile.Name }}
                        </td>
                      </tr>
                      <tr>
                        <td>薪資</td>
                        <td>
                          底薪: {{userSalary.Amount | amountFormat}}
                          <br>
                          勞健保: {{userSalary.Insurance | amountFormat}}
                        </td>
                      </tr>
                      <tr>
                        <td>績效</td>
                        <td>
                          {{ ((form.LoanRecord && form.LoanRecord.Sum) ?'預支'+form.LoanRecord.Sum: '') | amountFormat}}
                        </td>
                      </tr>
                      <tr>
                        <td>工作日誌獎金<br>({{form.TotalTaskWorkingItemBonus}})</td>
                        <td>
                          <!-- 工作日誌: -->
                          <v-simple-table dense v-if="form.TaskWorkingItems && form.TaskWorkingItems.length">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">工作日期</th>
                                  <th class="text-left">專案</th>
                                  <th class="text-left">任務</th>
                                  <th class="text-left">工作</th>
                                  <th class="text-left">時數</th>
                                  <th class="text-left" width="100px">獎金</th>
                                </tr>
                              </thead>
                              <!-- <thead>
                                <tr><th colspan="2">工作日誌</th></tr>
                              </thead> -->
                              <tbody>
                                <tr
                                  v-for="taskWorkingItem in form.TaskWorkingItems"
                                  :key="`薪資明細-獎金-日誌-${taskWorkingItem.ID}`"
                                >
                                  <td>{{ taskWorkingItem.Date | dateFormat }}</td>
                                  <td>{{ getTaskWorkingItemProject(taskWorkingItem).Name }}</td>
                                  <td>{{ getTaskWorkingItemTask(taskWorkingItem).Name }}</td>
                                  <td>{{ taskWorkingItem.Content }}</td>
                                  <td>{{ taskWorkingItem | hoursFormatOfTaskWorkingItem }}</td>
                                  <td>$ {{ taskWorkingItem.Bonus | amountFormat }}</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                          <span v-else>無</span>
                        </td>
                      </tr>
                      <tr>
                        <td>工單獎金<br>({{form.TotalWorkOrderBonus}})</td>
                        <td>
                          <v-simple-table dense v-if="form.WorkOrders && form.WorkOrders.length">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">工作日期</th>
                                  <th class="text-left">專案</th>
                                  <th class="text-left">任務</th>
                                  <th class="text-left">工作</th>
                                  <th class="text-left">時數</th>
                                  <th class="text-left" width="100px">獎金</th>
                                </tr>
                              </thead>
                              <!-- <thead>
                                <tr><th colspan="2">工作日誌</th></tr>
                              </thead> -->
                              <tbody>
                                <tr
                                  v-for="workOrder in form.WorkOrders"
                                  :key="`薪資明細-獎金-工單-${workOrder.ID}`"
                                >
                                  <td>{{ workOrder.Time | dateFormat }}</td>
                                  <td>{{ getWorkOrderProject(workOrder).Name }}</td>
                                  <td>{{ getWorkOrderTask(workOrder).Name }}</td>
                                  <td>{{ workOrder.Content }}</td>
                                  <td>{{ workOrder.EstimatedHours }}</td>
                                  <td width="100px">$ {{ workOrder.Amount | amountFormat }}</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                          <span v-else>無</span>
                        </td>
                      </tr>
                      <tr>
                        <td>出缺勤紀錄</td>
                        <td>
                          <v-row v-if="form.LeaveForms && form.LeaveForms.length">
                            <v-col cols="12">
                              <div
                                v-for="leaveForm in form.LeaveForms"
                                :key="`薪資明細-出缺勤-${leaveForm.ID}`"
                              >
                                {{ leaveForm.Category }}: {{ leaveForm | periodFormat }}
                              </div>
                            </v-col>
                          </v-row>
                          <span v-else>無</span>
                        </td>
                      </tr>
                      <tr>
                        <td>其他</td>
                        <td>
                          <span v-if="!isSignEnabled">{{form.Other}}</span>
                          <v-text-field
                            v-else
                            v-model="form.NewOther"
                            @input="onOtherChanged"
                            label="其他"
                            type="number"
                            step="1"
                            min="0"
                            max="1000000000"
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <td>總計</td>
                        <td>
                          {{form.Amount}}
                        </td>
                      </tr>
                      <tr>
                        <td>備註</td>
                        <td>
                          <span v-if="!isSignEnabled">{{form.Remark}}</span>
                          <v-textarea
                            v-else
                            v-model="form.Remark"
                            rows="3"
                            label="備註"
                          ></v-textarea>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          v-if="isSignEnabled"
          color="white darken-1"
          depressed
          outlined
          text
          @click="sign"
        >簽核</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import Avatar from "@/ui/components/avatar.vue";
import filterMixin from "@/data/filters/filter-mixin.vue";
import AppDataSetting from '@/data/app-data-setting.js'
import XMLGenerator from "@/data/excel/xml-generator-salary-detail.js";
import XLSXSaver from "@/data/excel/xlsx-saver.js";
import { hoursFormat } from '@/data/filters/formatter.js';
export default {
  mixins: [filterMixin],
  components: { Avatar },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    id: {
      type: Number,
      required: true,
      default: -1
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    form: {},
    defaultForm: {
      Name: ""
    }
  }),
  computed: {
    formRules() {
      return {};
    },
    formTitle() {
      if (this.form && this.form.UserID) {
        return "薪資明細 - " + this.user.Profile.Name;
      }
      return "薪資明細";
    },
    statusColor() {
      if (this.form.Status == "確認中") return "green";
      if (this.form.Status == "已審核") return "primary";
      return "";
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    editingIdx() {
      return this.$store.state.salary.list.findIndex(o => o.ID == this.id);
    },
    user() {
      return this.users.find(o => o.ID == this.form.UserID) || { Profile: {} };
    },
    isCurrentMonth () {
      let now = new Date()
      return now.getFullYear() == this.form.Year && now.getMonth()+1 == this.form.Month
    },
    isSignEnabled() {
      if (this.isCurrentMonth) return false
      return true
      // return this.form.Status == "確認中" && this.myLevel == 100;
    },
    userSalary() {
      return this.userSalaries.find(o => o.ID == this.form.UserSalaryID) || {};
    },
    loan() {
      if (!this.form.LoanRecord) return "";
      if (this.form.LoanRecord.Offset > 0)
        return `多欠${this.form.LoanRecord.Offset}`;
      if (this.form.LoanRecord.Offset < 0)
        return `還${this.form.LoanRecord.Offset}`;
      return "";
    },
    ...mapGetters([
      "users",
      "userPositions",
      "userDepartments",
      "userSalaries",
      "me",
      "myLevel",
      "myDepartment",
      'projects',
      'taskWorkingItems'
    ])
  },
  methods: {
    exportExcel() {
      var datas = [] // form.WorkOrders && form.TaskWorkingItems
      for(let taskWorkingItem of this.form.TaskWorkingItems || []) {
        datas.push({
          'project-name': this.getTaskWorkingItemProject(taskWorkingItem).Name,
          'task-name': this.getTaskWorkingItemTask(taskWorkingItem).Name,
          'hours': hoursFormat(taskWorkingItem.ActualHours, taskWorkingItem.ActualMinutes),
          'content': taskWorkingItem.Content,
          'money': taskWorkingItem.Bonus
        })
      }
      for(let workOrder of this.form.WorkOrders || []) {
        datas.push({
          'project-name': this.getWorkOrderProject(workOrder).Name,
          'task-name': this.getWorkOrderTask(workOrder).Name,
          'hours': workOrder.EstimatedHours,
          'content': workOrder.Content,
          'money': workOrder.Amount
        })
      }
      let result = XMLGenerator.generate(this, datas);

      var fileName = window.prompt(
        "請輸入匯出Excel檔之名稱",
        `傳動ERP-薪資系統-${this.user.Profile.Name}-績效明細匯出`
      );
      if (!fileName) {
        return window.alert("請輸入檔案名稱");
      }
      XLSXSaver.saveAs(result, fileName);
    },
    getTaskWorkingItemProject(item) {
      let task = AppDataSetting.attachTaskWorkingItemTask(this, item)
      if (!task) return {}
      let project = this.projects.find(o => o.ID === task.ProjectID)
      if (!project) return {}
      return project
    },
    getTaskWorkingItemTask(item) {
      let task = AppDataSetting.attachTaskWorkingItemTask(this, item)
      if (!task) return {}
      return task
    },
    getWorkOrderProject(workOrder) {
      let taskWorkingItem = this.taskWorkingItems.find(o=>o.ID === workOrder.TaskWorkingItemID)
      if (!taskWorkingItem) return {Name:'-'}
      return this.getTaskWorkingItemProject(taskWorkingItem)
    },
    getWorkOrderTask(workOrder) {
      let taskWorkingItem = this.taskWorkingItems.find(o=>o.ID === workOrder.TaskWorkingItemID)
      if (!taskWorkingItem) return {Name:'-'}
      return this.getTaskWorkingItemTask(taskWorkingItem)
    },
    close() {
      this.isShowDialog = false;
    },
    onOtherChanged() {
      let diff = this.form.NewOther - this.form.Other
      this.form.Amount += diff
      this.form.Other = this.form.NewOther
    },
    sign() {
      this.isLoading = true;

      this.form.Other = parseInt(this.form.Other);
      if (this.form.Other > 1000000000) {
        return alert("其他金額不可大於10億");
      }
      this.$services.salary
        .sign(this, this.form)
        .then(res => {
          this.$set(
            this.$store.state.salary.list[this.editingIdx],
            "Status",
            "已審核"
          );
          this.$set(
            this.$store.state.salary.list[this.editingIdx],
            "Other",
            this.form.Other
          );
          this.$set(
            this.$store.state.salary.list[this.editingIdx],
            "Remark",
            this.form.Remark
          );
          this.$set(
            this.$store.state.salary.list[this.editingIdx],
            "Amount",
            this.form.Amount
          );
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    resetForm() {
      if (!this.value) return;
      if (this.id < 0 || this.editingIdx < 0) {
        this.isLoading = false;
        alert("發生異常：無法找到編輯物件");
        return;
      }
      if (this.$refs.cardContent) {
        this.$nextTick(() => this.$refs.cardContent.scrollTo(0, 0));
      }
      let form = JSON.parse(
        JSON.stringify(this.$store.state.salary.list[this.editingIdx])
      );
      form.NewOther = form.Other
      if(form.TaskWorkingItems)form.TaskWorkingItems.sort((o1, o2) => new Date(o1.Date) - new Date(o2.Date));
      if(form.WorkOrders)form.WorkOrders.sort((o1, o2) => new Date(o1.Time) - new Date(o2.Time));
      this.form = form
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created() {
    this.resetForm();
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    }
  }
};
</script>